var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.7891C17.5228 21.7891 22 17.3119 22 11.7891C22 6.26621 17.5228 1.78906 12 1.78906C6.47712 1.78906 1.99997 6.26621 1.99997 11.7891C1.99997 17.3119 6.47712 21.7891 12 21.7891Z",
    stroke: "#0F0E0E",
    strokeWidth: 2.47368
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 8.27306C10.5 7.28306 11 6.78906 12 6.78906C13.246 6.78906 14 7.77806 14 8.76706C14 9.75606 13.5 10.2501 12 11.2401V12.7891M12 16.2891V16.7891",
    stroke: "#0F0E0E",
    strokeWidth: 2.47368,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.c6434e8b40a4fec968e0081e9abf9ee7.svg";
export { ForwardRef as ReactComponent };